export default __webpack_public_path__ + "static/media/emoji-pen.4c1c3d25.svg";